var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBkp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F3F1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6668 11.8916V15.3337C21.6668 15.8004 21.6668 16.0338 21.7577 16.212C21.8376 16.3688 21.965 16.4963 22.1218 16.5762C22.3001 16.6671 22.5335 16.6671 23.0002 16.6671H26.4423M23.3335 20.8337H16.6668M23.3335 24.167H16.6668M18.3335 17.5003H16.6668M21.6668 11.667H17.3335C15.9334 11.667 15.2333 11.667 14.6985 11.9395C14.2281 12.1792 13.8457 12.5616 13.606 13.032C13.3335 13.5668 13.3335 14.2669 13.3335 15.667V24.3337C13.3335 25.7338 13.3335 26.4339 13.606 26.9686C13.8457 27.439 14.2281 27.8215 14.6985 28.0612C15.2333 28.3337 15.9334 28.3337 17.3335 28.3337H22.6668C24.067 28.3337 24.767 28.3337 25.3018 28.0612C25.7722 27.8215 26.1547 27.439 26.3943 26.9686C26.6668 26.4339 26.6668 25.7338 26.6668 24.3337V16.667L21.6668 11.667Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBkp);
export default __webpack_public_path__ + "static/media/bkp.00ee49026bf0fe5b8b5d24fdb2f2b72c.svg";
export { ForwardRef as ReactComponent };